import { skipToken } from "@tanstack/react-query";
import { useCurrentWorkspace } from "@v2/contexts/WorkspaceDashboardContext";
import { useHasPaidSubscription } from "@v2/hooks/subscription";
import { workspaceRouter } from "@v2/trpc/routes/workspace";

export const useCanAddCustomDomainToShop = ({
  projectId,
}: {
  projectId?: string;
}) => {
  const workspace = useCurrentWorkspace();

  const { data: canAdd } = workspaceRouter.canAddCustomDomainToShop.useQuery(
    workspace?.id && projectId
      ? {
          projectId,
          workspaceId: workspace.id,
        }
      : skipToken,
  );

  const hasPaidSubscription = useHasPaidSubscription();

  return {
    canAdd: canAdd ?? false,
    hasPaidSubscription,
  };
};
